import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Buscar = () => {
    const [rut, setRut] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (rut.trim()) {
            navigate(`/ficha/${rut}`);
        } else {
            alert("Por favor, ingrese un RUT válido");
        }
    };

    return (
        <div className="container mt-5">
            <div className="card shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-center mb-4">Buscar Socio</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Ingrese el RUT</label>
                            <input
                                type="text"
                                className="form-control"
                                value={rut}
                                onChange={(e) => setRut(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-primary w-100">Buscar</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Buscar;
